import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'dcsgStripSpecialChars',
})
export class StripSpecialCharsPipe implements PipeTransform {
  public transform(value?: string, pattern?: string): string {
    // if value is undefined return empty string
    if (value === undefined) {
      return '';
    }

    if (pattern !== undefined) {
      return value.replaceAll(new RegExp(pattern, 'gi'), '');
    }

    return value.replaceAll(/[\s!@#$%^*(){}[\];'",<>./\\|?_+=`~‘’“”…′]/g, '');
  }
}
